// ULID generation and validation for commands, events, queries, and requests
import { ulid } from 'ulid';
/**
 * Generates a globally unique, time-sortable ID
 * Example: "01ARZ3NDEKTSV4RRFFQ69G5FAV"
 */
export function generateUniqueId() {
    return ulid();
}
// Convenience aliases for semantic clarity
export const generateCommandId = generateUniqueId;
export const generateEventId = generateUniqueId;
export const generateQueryId = generateUniqueId;
export const generateRequestId = generateUniqueId;
/**
 * Validates ULID format: 26 characters, base32 encoding
 * Example valid ID: "01ARZ3NDEKTSV4RRFFQ69G5FAV"
 */
export function isValidUlid(id) {
    if (!id)
        return false;
    // ULID is exactly 26 characters, case-insensitive base32
    return /^[0-9A-HJKMNP-TV-Z]{26}$/i.test(id);
}
//# sourceMappingURL=uniqueId.js.map